import React, { useEffect } from 'react';
import { useAuth } from '../../AuthContext';

function ThreadsConnect() {
    const myContext = useAuth();

    useEffect(() => {
        // Define the listener
        const handleMessage = (event) => {
            // SECURITY: Replace with your actual backend/frontend domain
           // if (event.origin !== "https://api.schedpilot.com" && event.origin !== window.location.origin) return;

            if (event.data.type === "threads-authenticated") {
                const mytoken = event.data.token;

                fetch('https://api.schedpilot.com/wp-json/api/v1/register-threads-token', {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ threadsToken: mytoken })
                })
                .then(res => res.json())
                .then(() => {
                    myContext.getAccountsData();
                })
                .catch(err => console.error("Error saving Threads token:", err));
            }
        };

        window.addEventListener("message", handleMessage);
        
        // Cleanup listener on unmount
        return () => window.removeEventListener("message", handleMessage);
    }, [myContext]);

    const handleThreadsConnect = () => {
        const clientId = "1295570568684205";
        // Ensure this matches exactly what is in your Meta App Dashboard
        const redirectUri = "https://api.schedpilot.com/wp-json/api/v1/threads-callback";
        const scope = "threads_basic,threads_content_publish";
        const state = "security_stat_123"; // Ideally dynamic

        const threadsUrl = `https://www.threads.net/oauth/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${scope}&response_type=code&state=${state}`;

        const width = 600, height = 700;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;

        const authWindow = window.open(
            threadsUrl,
            'ThreadsAuth',
            `toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=${width}, height=${height}, top=${top}, left=${left}`
        );

        const interval = setInterval(() => {
            if (!authWindow || authWindow.closed) {
                clearInterval(interval);
            }
        }, 1000);
    };

    return (
        <button className='btn btn-primary' onClick={handleThreadsConnect}>
            Connect Threads
        </button>
    );
}

export { ThreadsConnect };